



























































































































































import Vue from 'vue'
import { Tag, SystemType, Manufacturer, License } from '@/class'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'

const nameSort = function(a, b): number {
  if (a.text.toUpperCase() < b.text.toUpperCase()) return -1
  if (a.text.toUpperCase() > b.text.toUpperCase()) return 1
  return 0
}

export default Vue.extend({
  name: 'frame-filter',
  data: () => ({
    sourceFilter: [],
    licenseFilter: [],
    tagFilter: [],
    systemTypeFilter: [],
    sp: '',
    spType: '',
    lcpFilter: [],
    licenseLevel: '',
    licenseLevelType: '',
  }),
  computed: {
    manufacturers(): Manufacturer[] {
      return this.$store.getters
        .getItemCollection('Manufacturers')
        .map(x => ({ text: x.Name, value: x.ID }))
        .sort(nameSort)
    },
    licenses(): License[] {
      return this.$store.getters
        .getItemCollection('Licenses')
        .map(x => ({ text: x.Name.toUpperCase(), value: x.ID }))
        .sort(nameSort)
    },
    systemTypes(): SystemType[] {
      return Object.keys(SystemType)
        .map(k => SystemType[k as any])
        .filter(k => k !== 'Integrated')
        .sort() as SystemType[]
    },
    tags(): Tag[] {
      return this.$_.uniqBy(
        [].concat(
          this.$store.getters
            .getItemCollection('MechSystems')
            .flatMap(x => x.Tags)
            .filter(x => !x.FilterIgnore && !x.IsHidden)
        ),
        'ID'
      )
    },
    lcps(): string[] {
      return getModule(CompendiumStore).lcpNames
    },
  },
  methods: {
    clear() {
      this.sourceFilter = []
      this.licenseFilter = []
      this.tagFilter = []
      this.systemTypeFilter = []
      this.sp = ''
      this.spType = ''
      this.lcpFilter = []
      this.licenseLevel = ''
      this.licenseLevelType = ''
    },
    updateFilters() {
      const fObj = {} as any
      if (this.lcpFilter && this.lcpFilter.length) fObj.LcpName = [this.lcpFilter]
      if (this.spType && !isNaN(parseInt(this.sp))) fObj[`SP_${this.spType}`] = parseInt(this.sp)
      if (this.licenseLevelType && !isNaN(parseInt(this.licenseLevel))) fObj[`LL_${this.licenseLevelType}`] = parseInt(this.licenseLevel)
      if (this.sourceFilter && this.sourceFilter.length) fObj.Source = [this.sourceFilter]
      if (this.licenseFilter && this.licenseFilter.length) fObj.License = [this.licenseFilter]
      if (this.tagFilter && this.tagFilter.length) fObj.Tags = this.tagFilter
      if (this.systemTypeFilter && this.systemTypeFilter.length) fObj.Type = [this.systemTypeFilter]
      this.$emit('set-filters', fObj)
    },
  },
})
